<template>
  <div>
    <cancel-verification-modal
        :is-dialog-visible="isAuthorizationCancelModalVisible"
        @visibilityChanged="setIsAuthorizationCancelModalVisible" />
    <div class="ring-card-action-box__text ring-card-action-box__title">
      Account Verification
    </div>
    <div
        v-if="isApprovedStatus"
        class="flex flex-col justify-between content-center">
      <div
          class="justify-between content-center">
        <span
            v-if="expiresAt"
            class="ring-card-action-box__text ring-card-action-box__description">
          Expires at: &nbsp;
          <time-zone-formatter :current-time="expiresAt" />
        </span>

        <div
            v-if="isApprovedStatus"
            class="ring-card-action-box__text-success ring-card-action-box__text">
          Account Verified
        </div>
      </div>
    </div>

    <div
        v-else-if="isVerificationRequired"
        class="ring-card-action-box__text ring-card-action-box__text-error">
      Verification Required
    </div>

    <div v-else-if="isPending">
      <div class="ring-card-action-box__text ring-card-action-box__description">
        {{ statusMessage }}
      </div>

      <div class="ring-card-action-box__text ring-card-action-box__text-warning">
        Pending
      </div>
      <el-tooltip
          class="item"
          effect="dark"
          content="Cancel current verification authorization"
          placement="bottom-start">
        <el-link
            class="cancel-verification"
            @click="showCancelAuthorizationModal">
          Cancel Verification
        </el-link>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
import CancelVerificationModal from "@/NewUI/components/customer/authorizations/cancel/CancelVerificationModal";

export default {
  name: "AccountVerificationPanel",
  components: {
    CancelVerificationModal,
  },
  props: {
    expiresAt: {
      type: String,
      required: false,
      default: undefined,
    },
    isApprovedStatus: {
      type: Boolean,
      required: true,
    },
    isVerificationRequired: {
      type: Boolean,
      required: true,
    },
    isPending: {
      type: Boolean,
      required: false,
    },
    statusMessage: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isAuthorizationCancelModalVisible: false,
      isCancelAuthButtonVisible: false,
      icons: {
        cancelIcon: require("@/assets/icons/lte.svg"),
      },
    };
  },
  methods: {
    setIsAuthorizationCancelModalVisible(value) {
      this.isAuthorizationCancelModalVisible = value;
    },
    showCancelAuthorizationModal() {
      this.isAuthorizationCancelModalVisible = true;
    },
  },
};
</script>

<style scoped>
.cancel-verification {
  font-size: 11px;
  font-style: italic;
  margin-top: -10px;
}
</style>
